(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/kyc/kyc-questions.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/kyc/kyc-questions.js');
'use strict';

const _React = React,
  useRef = _React.useRef,
  useEffect = _React.useEffect,
  useCallback = _React.useCallback;
const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory;
const helpers = svs.myProfile.react.pages.kyc.kycHelpers;
const routes = svs.myProfile.constants.routes;
const showTechnicalKycError = svs.myProfile.react.pages.kyc.dialogs.showTechnicalKycError;
const KycQuestions = () => {
  const kycContainerRef = useRef();
  const history = useHistory();
  const navigateToNext = useCallback(async () => {
    const returnUrl = helpers.getReturnUrl() || svs.core.urlMapping.get('newCustomer');
    if (returnUrl) {
      svs.core.flash('success', {
        title: 'Dina svar har sparats',
        branding: svs.ui.dialog.branding.TUR,
        time: svs.ui.dialog.autoClose.SHORT
      }, () => {
        window.location = returnUrl;
      });
    } else {
      history.push(routes.MY_PROFILE_KYC);
      const dialog = new svs.ui.dialog.Confirm({
        branding: svs.ui.dialog.branding.TUR,
        area: svs.ui.dialog.area.POPUP,
        autoClose: svs.ui.dialog.autoClose.SHORT,
        title: 'Dina svar har sparats',
        actions: [{
          type: svs.ui.dialog.button.SECONDARY,
          title: 'Okej'
        }]
      });
      svs.ui.dialog.api.add(dialog);
    }
  }, [history]);

  const onKycQuestionsComplete = useCallback(async (context, kycStatus) => {
    if (kycStatus) {
      const showTechnicalKycMessage = () => new Promise(resolve => {
        svs.core.module.load('/cl/components/kyc-messages', null, () => {
          svs.components.kyc_messages.showKYCMessage(kycStatus, () => resolve());
        });
      });
      await showTechnicalKycMessage();
    }
    navigateToNext();
  }, [navigateToNext]);
  useEffect(() => {
    const kycErrorCallback = async () => {
      await showTechnicalKycError();
      onKycQuestionsComplete();
    };
    const onKycCancel = () => {
      history.push(routes.MY_PROFILE_KYC);
    };
    svs.core.module.load('/cl/components/react:kyc', null, function () {
      svs.components.kyc.init(kycContainerRef.current, {
        context: this,
        onComplete: onKycQuestionsComplete,
        showOverview: false,
        onCancel: onKycCancel,
        onError: kycErrorCallback
      });
    }, false);
  }, [history, onKycQuestionsComplete]);
  return React.createElement("div", {
    ref: kycContainerRef
  });
};
svs.myProfile.react.pages.kyc.KycQuestions = KycQuestions;

 })(window);